import api, { ApiResponse } from './api';

interface Resp<T> {
  success: boolean;
  data: T;
}

export interface InboundAlias {
  alias: string;
  address: string;
}

export interface InboundToken {
  code: string | null;
  expiresAt: string | null;
}

// Código de verificação que a distribuidora mandou ao alias (vale 5 min) —
// o assistente consulta a cada 5 s enquanto o passo está aberto (C2)
export const getInboundTokenService = (): ApiResponse<Resp<InboundToken>> =>
  api({ method: 'GET', url: 'inbound-email/token', useToken: true });

// "Pronto, cadastrei": o imóvel passa a "aguardando 1ª fatura" (C3)
export const markInboundSetupService = (
  consumerUnitId: string
): ApiResponse<{ success: boolean }> =>
  api({
    method: 'POST',
    url: 'inbound-email/setup',
    data: { consumerUnitId },
    useToken: true,
  });

// Gera (idempotente) e retorna o endereço de recebimento do usuário
export const generateAliasService = (): ApiResponse<Resp<InboundAlias>> =>
  api({ method: 'POST', url: 'inbound-email/alias', useToken: true });
